// TODO: This is a temporary solution for MVP. This file should be removed, and the data should come directly from CarTrawler’s endpoint (SPASHOP-961).
import { getPersistedCarProductData } from "../carPersistence";

const DEFAULT_CURRENCY = "USD";

/**
 * Retrieves the persisted CarTrawler product data and transforms insurance and booking total
 * information into the data structure used by checkout totals components.
 *
 * @returns {Object} Object containing a getBreakdown method.
 */
export const getCarInsuranceTotals = () => {
  const product = getPersistedCarProductData() || {};
  const { insuranceData = {}, insuranceSelected = false, price = {} } = product;

  const currency = price.totalPayAtDesk?.currencyCode || DEFAULT_CURRENCY;

  const insuranceCost = insuranceData?.planForQuoteRS?.PlanCost;
  const insuranceAmount = insuranceSelected ? parseFloat(insuranceCost?.["@Amount"]) || 0 : 0;

  return {
    getBreakdown: () => ({
      insurance: {
        currencyData: { value: insuranceAmount, currencyCode: currency },
        label: "LABEL__CHECKOUT__CAR_INSURANCE",
      },
      carTotalDue: {
        currencyData: { value: insuranceAmount, currencyCode: currency },
        label: "LABEL__CHECKOUT__CAR_BOOKING_TOTAL",
      },
    }),
    getTotals: () => ({
      insuranceTotal: { currencyData: { currencyCode: currency, value: insuranceAmount } },
    }),
  };
};

/**
 * This function retrieves the persisted CarTrawler product data and transforms it into
 * the same data structure used by the checkout totals components for price breakdown display.
 *
 * @returns {Object} Object containing getBreakdown, getTotals, getTotalDueNow, and hasProduct methods.
 */
export const getCarTotalsMethods = () => {
  const product = getPersistedCarProductData() || {};
  const { vehicle = {}, price = {}, includes = {}, tpaExtensions = {} } = product;
  const currency = price.totalPayAtDesk?.currencyCode || DEFAULT_CURRENCY;
  const totalAmount = parseFloat(price.totalPayAtDesk?.amount) || 0;
  const taxesAndFees = (tpaExtensions.Fees || []).reduce(
    (sum, fee) => sum + parseFloat(fee["@Amount"] || 0),
    0
  );
  const carCostExcludingTaxes = totalAmount - taxesAndFees;

  return {
    getBreakdown: () => ({
      carType: {
        label: "LABEL__CHECKOUT__CAR_TYPE",
        value: vehicle.vehicleCategory?.type || "",
      },
      carCost: {
        currencyData: { value: carCostExcludingTaxes, currencyCode: currency },
        label: "LABEL__CHECKOUT__CAR_COST",
      },
      totalTaxesAndFees: {
        currencyData: { value: taxesAndFees, currencyCode: currency },
        label: "LABEL__CHECKOUT__CAR_TAXES_FEES",
      },
      mileage: {
        charge: 0,
        label: "LABEL__CHECKOUT__MILEAGE",
        value: includes.vehicleRateDistance?.isUnlimited ? "Unlimited" : "",
      },
      totalDueAtReturn: {
        currencyData: { value: totalAmount, currencyCode: currency },
        label: "LABEL__CHECKOUT__TOTAL_DUE_AT_RETURN",
      },
    }),
    getTotals: () => ({
      totalFare: { currencyData: { currencyCode: currency, value: totalAmount } },
      baseFare: { currencyData: { currencyCode: currency, value: carCostExcludingTaxes } },
      totalTaxesAndFees: { currencyData: { currencyCode: currency, value: taxesAndFees } },
    }),
    getTotalDueNow: () => ({
      currencyData: {
        currencyCode: currency,
        value: parseFloat(price.totalPayNow?.amount) || 0,
      },
    }),
    hasProduct: () => Object.keys(product).length > 0,
  };
};
